import PageLayout from '../components/layout/PageLayout'
import ConsultationsHeroSection from '../components/sections/consultations/ConsultationsHeroSection'
import ConsultationsListingSection from '../components/sections/consultations/ConsultationsListingSection'
import AuthenticitySection from '../components/sections/consultations/AuthenticitySection'
import ProcessSection from '../components/sections/consultations/ProcessSection'
import StandardsSection from '../components/sections/consultations/StandardsSection'

export default function ConsultationsPage() {
  return (
    <PageLayout className="bg-[#403c3d]/5 text-[#151b21] antialiased min-h-screen flex flex-col">
      <main className="grow">
        <ConsultationsHeroSection />
        <ConsultationsListingSection />
        <AuthenticitySection />
        <ProcessSection />
        <StandardsSection />
      </main>
    </PageLayout>
  )
}
